import { render, staticRenderFns } from "./clifor.vue?vue&type=template&id=7f839ab2"
import script from "./clifor.vue?vue&type=script&lang=js"
export * from "./clifor.vue?vue&type=script&lang=js"
import style0 from "./clifor.vue?vue&type=style&index=0&id=7f839ab2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports